import React from 'react';
import {withTranslation} from 'react-i18next';
import AppIcon from '../AppIcon';
import './salesPitch.css';

const benefits = [
  ['lock', 'PrivateSharing', 'PrivateSharingDescription'],
  ['comments outline', 'CollectUnbiasedFeedback', 'CollectUnbiasedFeedbackDescription'],
  ['globe', 'AnalyzeReadingPatterns', 'AnalyzeReadingPatternsDescription'],
];

export const AuthorPitch = ({t}) => (
  <section aria-label={t('AuthorsAndPublishers')}>
    <h2 style={{textAlign: 'center'}}>{t('AuthorsAndPublishers')}</h2>
    <p style={{textAlign: 'center'}}>{t('FindOutWhatYourReadersThink')}</p>
    <img src='/assets/images/author-pitch.png' alt=''
      style={{float: 'left', width: 110, maxWidth: '35%', marginRight: 16}} />
    <ul style={{listStyle: 'none', padding: 0}}>
      {benefits.map(([icon, heading, description]) => (
        <li key={heading} style={{display: 'flex', gap: 8, marginBottom: 12}}>
          <span aria-hidden='true'><AppIcon name={icon} /></span>
          <span><strong>{t(heading)}</strong><br />{t(description)}</span>
        </li>
      ))}
    </ul>
  </section>
);

export default withTranslation()(AuthorPitch);
